module.exports = __webpack_public_path__ + "img/olimpo2.5458a35a.webp";